"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const stack_1 = require("@react-navigation/stack");
const react_1 = __importStar(require("react"));
function StackNavigator({ authorizationOptions, children, initialRouteName, screenOptions, }) {
    const wrappedChildren = react_1.useMemo(() => {
        if (!authorizationOptions)
            return children;
        const { isSignout, permissions = [] } = authorizationOptions;
        return react_1.default.Children.toArray(children).filter((child) => {
            if (!react_1.default.isValidElement(child))
                return true;
            const { access = 'public', permission } = (child.props.options || {});
            if (isSignout && access === 'private')
                return false;
            if (!isSignout && access === 'protected')
                return false;
            if (!!permission && permissions.findIndex((v) => v === permission) < 0)
                return false;
            return true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authorizationOptions]);
    const navigation = native_1.useNavigationBuilder(native_1.StackRouter, {
        children: wrappedChildren,
        initialRouteName,
        screenOptions,
    });
    return react_1.default.createElement(stack_1.StackView, navigation);
}
const createStackNavigator = native_1.createNavigatorFactory(StackNavigator);
exports.default = createStackNavigator;
